export interface Illustration {
  alt: string;
  url: string;
}

const ILLUSTRATION_ASSET_URL = 'https://assets.nerdwallet.com/blog/wp-content/uploads';

export const ILLUSTRATIONS: Record<string, Illustration> = {
  cashbackCC: {
    alt: 'One blue credit card with a green card behind it.',
    url: `${ILLUSTRATION_ASSET_URL}/2023/12/cashback-cc-desktop.png`,
  },
  coinsCC: {
    alt: 'One blue credit card on a flat surface with coins on both sides.',
    url: `${ILLUSTRATION_ASSET_URL}/2023/12/creditcard-coins-desktop.png`,
  },
  greenCC: {
    alt: 'A green credit card.',
    url: `${ILLUSTRATION_ASSET_URL}/2023/12/creditcard-desktop.png`,
  },
  travelCC: {
    alt: 'A blue credit card with a golden plane at the bottom and a palm tree at the top.',
    url: `${ILLUSTRATION_ASSET_URL}/2023/12/travel-cc-desktop.png`,
  },
  bankDeposit: {
    alt: 'A green bank that has a coin slot at the top where a hand is depositing a coin.',
    url: `${ILLUSTRATION_ASSET_URL}/2023/12/bank-deposit-desktop.png`,
  },
  bank: { alt: 'A green bank.', url: `${ILLUSTRATION_ASSET_URL}/2023/12/bank-desktop.png` },
  womanDevice: {
    alt: 'A person looking at a mobile phone.',
    url: `${ILLUSTRATION_ASSET_URL}/2023/12/woman-device-desktop.png`,
  },
  cashCoins: {
    alt: 'Cash and coins.',
    url: `${ILLUSTRATION_ASSET_URL}/2023/12/cash-coins-desktop.png`,
  },
  cashPercent: {
    alt: 'Cash with a green percentage sign on the top-right corner.',
    url: `${ILLUSTRATION_ASSET_URL}/2023/12/cash-percent-desktop.png`,
  },
  approvedDocuments: {
    alt: 'Paper documents wrapped with a ribbon that has a checkmark on it.',
    url: `${ILLUSTRATION_ASSET_URL}/2023/12/approved-documents-desktop.png`,
  },
  cashCalculator: {
    alt: 'A calculator with cash next to it.',
    url: `${ILLUSTRATION_ASSET_URL}/2023/12/calculator-desktop.png`,
  },
  womanSitting: {
    alt: 'Woman sitting on top of some coins.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/woman-sitting-desktop.png`,
  },
  walletCard: {
    alt: 'Wallet with a gold credit card.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/wallet-card-desktop.png`,
  },
  storefront: {
    alt: 'Storefront with a door and window.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/storefront-desktop.png`,
  },
  storeSign: {
    alt: 'Sign with a "we are open" text.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/store-sign-desktop.png`,
  },
  savingMoney: {
    alt: 'Jar with some coins inside and some cash on the side.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/saving-money-desktop.png`,
  },
  moneyCard: {
    alt: 'Some cash and a credit card.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/money-card-desktop.png`,
  },
  laptopSearch: {
    alt: 'Couple of hands typing on a laptop.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/laptop-search-desktop.png`,
  },
  handPayment: {
    alt: 'Hand with a blue credit card.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/hand-payment-desktop.png`,
  },
  holdingCard: {
    alt: 'Hand holding a credit card.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/hand-holding-card-desktop.png`,
  },
  creditCard: {
    alt: 'Red credit card standing alone.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/generic-credit-card-desktop.png`,
  },
  genericCard: {
    alt: 'A note, a pencil, and a green credit card.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/generic-card-desktop.png`,
  },
  cardPayment: {
    alt: 'Some bills and a red card.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/02/card-payment-desktop.png`,
  },
  upwardChart: {
    alt: 'Laptop with upward chart.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/03/upward-chart.png`,
  },
  upwardChartSpot: {
    alt: 'Green circle with upward chart.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/03/upward-chart-spot.png`,
  },
  shoppingCart: {
    alt: 'Green shopping card over cellphone.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/03/shopping-cart.png`,
  },
  shoppingBagSpot: {
    alt: 'Green shopping bag.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/03/shopping-bag-spot.png`,
  },
  restaurant: { alt: 'Green restaurant.', url: `${ILLUSTRATION_ASSET_URL}/2024/03/restaurant.png` },
  restaurantSpot: {
    alt: 'Blue restaurant.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/03/restaurant-spot.png`,
  },
  paycheckSpot: {
    alt: 'Green paycheck.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/03/paycheck-spot.png`,
  },
  invoiceSpot: { alt: 'Blue invoice.', url: `${ILLUSTRATION_ASSET_URL}/2024/03/invoice-spot.png` },
  calculatorHandSpot: {
    alt: 'Hand with blue calculator.',
    url: `${ILLUSTRATION_ASSET_URL}/2024/03/calculator-hand-spot.png`,
  },
};
